<template>
  <div>
    <baseFrame
      :saveText='"保存"'
      submitText='提交'
      clearText=''
      @save='save'
      @submit='submit'
      :saveLoading='saveLoading'
      :submitLoading='submitLoading'
      :idText='!$route.params.id?"门店名称 ":"付款单号 "'
      :id='$route.params.id?info.financePayment.code:storeInfo.name'
      :infosArr='infosArr'>
    <div slot='content'>

    <lk-card class="mb16" title="付款单信息">
      <lk-form
      :label-width="134"
      label-position="right"
      :model='info' :rules="ruleValidate"
      >
      <lk-row :gutter='16'>
        <lk-col span='10'>
          <lk-form-item label='供应商名称:'>
            <lk-select :disabled='disableSupplier' filterable clearable v-if="!info.financePayment.supplierName" v-model="info.financePayment.supplierId" @on-change='handleChange'>
              <lk-option v-for="(item,index) in suppliers" :key="index" :value="item.supplierId">{{item.supplierName}}</lk-option>
            </lk-select>
            <span>{{info.financePayment.supplierName}}</span>
          </lk-form-item>
        </lk-col>
      </lk-row>
        <lk-row :gutter='16'>

       <lk-col span='10'>
          <lk-form-item label='发票总金额:'>
            <span>{{amount.invoiceAmount}}</span>
            <!-- <lk-input clearable :maxlength='100' placeholder='请输入' v-model="info.financePayment.invoiceAmount"></lk-input> -->
          </lk-form-item>
        </lk-col>
        <lk-col span='10' offset='2'>
          <lk-form-item label='发票总税额:'>
            <span>{{amount.totalInvoiceTax}}</span>

          </lk-form-item>
        </lk-col>
       <lk-col span='10'>
          <lk-form-item label='总金额:'>
            <span>{{amount.totalPrice}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='10' offset='2'>
          <lk-form-item label='总税额:'>
            <span>{{amount.tax}}</span>
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row>
         <lk-col span='22'>
          <lk-form-item label='付款明细:'>
            <div class="mb16">
              <lk-button type='primary' @click="showPayables=true;getData()" :disabled='!info.financePayment.supplierId || disableEdit'>新增</lk-button>
            </div>
            <div class="PaymentPayables">
              <lk-table :columns='columns' :data='PayablesList' border    class='cancelTableShadow'></lk-table>
              </div>
          </lk-form-item>
            <lk-col span='10'>
          <lk-form-item label='备注:'>
            <lk-input clearable v-model="info.financePayment.comment" :maxlength='100' placeholder='请输入' ></lk-input>
          </lk-form-item>
        </lk-col>
        </lk-col>
      </lk-row>
      </lk-form>
    </lk-card>
    <lk-card title="付款记录">
      <lk-form
        :label-width="134"
        label-position="right"
      >
        <lk-row>
          <lk-col span="10">
            <lk-form-item label="已支付金额:">
              <span>{{paidAmount}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span="22">
            <lk-form-item label="付款记录:">
              <div class="mb16">
                <lk-button type="primary" @click="handleShowAdd">新增</lk-button>
              </div>
              <lk-table :columns="paidColumns" :data="paidList" border></lk-table>
            </lk-form-item>
          </lk-col>
        </lk-row>
      </lk-form>
    </lk-card>

    </div>
    </baseFrame>
    <lk-modal v-model="showPayables" title="付款明细" width='850'>
      <div class="modelContent">
        <div class="params">
          <lk-form
           :label-width='75'
          label-position="right"
          >
          <lk-row :gutter='16'>
            <lk-col span='8'>
              <lk-form-item label='发票编码:'>
                <lk-input clearable :maxlength='100' placeholder='请输入' v-model="PayablesQuery.invoiceCode"></lk-input>
              </lk-form-item>
            </lk-col>
            <lk-col span='8'>
              <lk-form-item label='开票时间:'>
                <timeStampDatePicker clearable v-model="PayablesQuery.invoiceDate"></timeStampDatePicker>
              </lk-form-item>
            </lk-col>
            <lk-col span='8'>

                <lk-button type='primary' class="mr8" @click="handleSearch">查询</lk-button>
                <lk-button @click="PayablesQuery.invoiceCode='';PayablesQuery.invoiceDate=null">重置</lk-button>

            </lk-col>
          </lk-row>
          </lk-form>
        </div>
        <div class="table mb16">
          <div style="position: relative;">
            <loading v-show="payableLoading"></loading>
            <lk-table border :columns='PayablesColumns' :data='tempPayablesList' @on-selection-change='handleSelect'></lk-table>
          </div>
        </div>
         <div style="text-align:right">
      <lk-page :total="PayablesCount" size="small" show-sizer show-elevator @on-change='handlePayablesPage' @on-page-size-change='handlePayablesSize'></lk-page>
    </div>
      </div>
        <div slot="footer">
          <span class="mr8">已选： {{tempPayables.length}}项</span>
              <lk-button @click="showPayables=false">取消</lk-button>
              <lk-button @click="confirmPayables" type='primary'>确定</lk-button>
            </div>
    </lk-modal>
    <DTPModal v-model="changeSupplier"
    content='一旦更改供应商名称，将清空已添加的付款明细和记录，是否继续？'
    @confirm="confirmChangeSupplier"
     @handleCancel='info.financePayment.supplierId=tempSupplier;changeSupplier=false'
    ></DTPModal>

    <!-- 添加付款记录 开始 -->
    <lk-modal
      v-model="modal.visiable"
      :mask-closable="false"
      title="付款信息"
      @on-cancel="cancelModal"
    >
      <lk-form
        label-position="right"
        :label-width="150"
        :rules="formRules"
        :model="formModel"
        ref="form"
      >
        <div class="modalContainer">
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="付款类型:" prop="payWay">
                <lk-select
                  class="item"
                  placeholder="请选择"
                  @on-change="handleTypeChange"
                  v-model.trim="formModel.payWay">
                  <lk-option
                    v-for="(item) in payWayMap"
                    :key="item[0]"
                    :disabled="payTypes.includes(item[0]) || disablePreRecord(item[0])"
                    :value="item[0]">{{ item[1] }}</lk-option>
                </lk-select>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16" v-if="formModel.payWay === 5">
            <lk-col :span="20">
              <lk-form-item label="预付记录:" prop="prepaymentId">
                <lk-select
                  class="item"
                  placeholder="请选择"
                  label-in-value
                  v-model.trim="formModel.prepaymentId"
                  @on-change="handlePreRecordChange">
                  <lk-option
                    v-for="(item) in preRecordList"
                    :key="item.id"
                    :value="item.id">{{item.payItem}}</lk-option>
                </lk-select>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="付款金额:" prop="amount">
                <dtp-input-number
                  style="width: 100%"
                  :min="-9999999999.99"
                  :max="9999999999.99"
                  :precision="2"
                  :active-change="false"
                  v-model="formModel.amount">
                </dtp-input-number>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="预付可用金额:">
                <span>{{formModel.allAvailablePrepaymentAmount}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="备注:" prop="remark">
                <lk-input
                  class="item"
                  clearable
                  placeholder=""
                  v-model.trim="formModel.remark"
                  :maxlength="100">
                </lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </div>
      </lk-form>
      <div slot="footer">
        <div>
          <lk-button @click="cancelModal">取消</lk-button>
          <lk-button type="primary" @click="handleDoPrePaymentAdd" :loading="modal.loading">确定</lk-button>
        </div>
      </div>
    </lk-modal>
    <!-- 添加付款记录 结束 -->
  </div>
</template>
<script>
import utils from '../../libs/utils';
import baseFrame from '../../components/frame/BaseFrame.vue';
import DTPModal from '../../components/DTPModal.vue';
import finance from '../../services/finance';
import loading from '../../components/LoadingSpan.vue';
import DtpInputNumber from '../../components/DtpInputNumber';

export default {
  name: 'PaymentInfo',
  components: {
    baseFrame,
    DTPModal,
    loading,
    DtpInputNumber,
  },
  computed: {
    storeInfo() {
      return this.$store.state.storeInfo;
    },
    selectedIds() {
      const result = [];
      // this.info.financePayableInfoList = [];
      this.PayablesList.forEach((item) => {
        // this.info.financePayableInfoList.push({
        //   purchaseInspectionInfo: {
        //     id: item.purchaseInspectionInfoId,
        //   },
        // });
        result.push(item.id);
      });
      return result;
    },
    amount() {
      const result = {
        tax: 0,
        totalPrice: 0,
        totalInvoiceTax: 0,
        invoiceAmount: 0,
        checkTax: false,
      };
      if (this.PayablesList.length) {
        // const firstTax = this.PayablesList[0].purchaseReceiptInfoTaxRate;
        this.PayablesList.forEach((item) => {
          result.tax += item.totalTax;
          result.totalInvoiceTax += item.invoiceTotalTax;

          result.totalPrice += item.amount;
          result.invoiceAmount += item.invoiceAmount;
          // if (item.purchaseReceiptInfoTaxRate !== firstTax) {
          //   result.checkTax = true;
          // }
        });
      }
      // result.tax;
      result.tax = result.tax.toFixed(2);
      result.totalPrice = result.totalPrice.toFixed(2);
      result.invoiceAmount = result.invoiceAmount.toFixed(2);
      result.totalInvoiceTax = result.totalInvoiceTax.toFixed(2);

      return result;
    },
    paidAmount() {
      // return this.info.finishPaymentRecordAmount || 0;
      let total = 0;
      this.paidList.forEach((item) => {
        total += item.amount;
      });
      return utils.fixNumber(total, 2); // total;
    },
    payWayMap() {
      return this.$store.state.publicParams.payWayMap;
    },
    isPaymentAdd() {
      return this.$route.name === 'paymentAdd' || this.info.financePayment.status === 1;
    },
    payTypes() {
      /*
     * 第一次审批：
       付款类型A 100元
       付款类型B  80元
       审批结果：通过

       第二次审批，如果是这样不可以：
       付款类型A  200元
       付款类型A  100元

       第二次审批，如果是这样可以：
       付款类型A  200元
       付款类型C  100元

       如果第二次审批结果是 通过，那么 付款记录是有4条：
       付款类型A 100元
       付款类型B  80元
       付款类型A  200元
       付款类型C  100元
     * */
      const result = [];
      this.paidList.forEach((item) => {
        const condition = this.isPaymentAdd ? item.status === 1 : ((item.status === 1 || item.status === 4));
        if (condition) {
          if (this.modal.type === 2 && item.payWay !== this.formModel.payWayBak) {
            result.push(item.payWay);
          } else if (this.modal.type === 1) {
            result.push(item.payWay);
          }
        }
      });
      return result;
    },
    disableEdit() {
      // 付款单首次付款记录审批通过后，付款明细不可编辑，即不可删除原有明细，不可添加新的明细
      return this.$route.name === 'paymentEdit' && this.info.financePayment.status === 3;
    },
  },
  data() {
    return {
      financePayment: '',
      infosArr: [],
      disableSupplier: false,
      PayablesQuery: {
        invoiceCode: '',
        invoiceDate: null,
      },
      isClear: true,
      changeSupplier: false,
      saveLoading: false,
      submitLoading: false,
      suppliers: [],
      tempPayables: [],
      tempPayablesList: [],
      payableLoading: false,
      PayablesList: [],
      showPayables: false,
      columns: [
        // { type: 'selection', width: 60 },
        { title: '序号', type: 'index', minWidth: 116 },
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.subColumns,
              data: params.row.subList,
            },
          }),
        },
        // { title: '单据来源', key: 'purchaseMedicineDrugSerialCode', minWidth: 116 },
        // { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '应付单号', key: 'code', minWidth: 116 },
        { title: '发票编码', key: 'invoiceCode', minWidth: 116 },
        { title: '发票时间', key: 'invoiceDate', minWidth: 116 },
        { title: '发票总金额', key: 'invoiceAmount', minWidth: 116 },
        { title: '发票总税额', key: 'invoiceTotalTax', minWidth: 116 },

        // { title: '供应商名称', key: 'supplierName', minWidth: 116 },

        // { title: '金额', key: 'amount', minWidth: 116 },
        // { title: '创建人', key: 'createUserName', minWidth: 126 },
        // { title: '单位', key: 'purchaseMedicineDrugMinimumPackagingUnit', minWidth: 116 },
        // { title: '数量', key: 'purchaseInspectionInfoPassNum', minWidth: 116 },
        {
          title: '操作',
          fixed: 'right',
          width: 100,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                disabled: this.disableEdit,
              },
              on: {
                click: () => {
                  // console.log(params);

                  this.PayablesList.splice(params.index, 1);
                  // console.log(this.PayablesList);

                  this.$Message.success('删除成功');
                },
              },
            }, '删除'),
          ]),
        },
      ],
      PayablesColumns: [
        { type: 'selection', width: 60 },
        { title: '应付单号', key: 'code', minWidth: 116 },
        { title: '发票编码', key: 'invoiceCode', minWidth: 116 },
        { title: '发票时间', key: 'invoiceDate', minWidth: 116 },
        { title: '发票总金额', key: 'invoiceAmount', minWidth: 116 },
        { title: '发票总税额', key: 'invoiceTotalTax', minWidth: 116 },
        // { title: '序号', type: 'index', minWidth: 116 },
        // { title: '应付单号', key: 'code', minWidth: 116 },
        // { title: '验收单号', key: 'code', minWidth: 116 },
        // { title: '商品通用名称', key: 'code', minWidth: 116 },
        // { title: '商品通用名称', key: 'code', minWidth: 116 },
        // { title: '发票编码', key: 'invoiceCode', minWidth: 116 },
        // { title: '发票日期', key: 'invoiceDate', minWidth: 116 },
        // { title: '门店名称', key: 'storeName', minWidth: 116 },
        // { title: '门店名称', key: 'storeName', minWidth: 116 },
        // { title: '供应商名称', key: 'supplierName', minWidth: 116 },
        // { title: '单价', key: 'purchaseReceiptInfoPriceBeforeTax', minWidth: 116 },
        // { title: '金额', key: 'amount', minWidth: 116 },
        // { title: '创建人', key: 'createUserName', minWidth: 116 },
        // { title: '发票编码', key: 'invoiceCode', minWidth: 116 },
        // { title: '开票日期', key: 'invoiceDate', minWidth: 116 },
        // { title: '剂型', key: 'purchaseMedicineDosageForm', minWidth: 116 },
        // { title: '单位', key: 'purchaseMedicineDrugMinimumPackagingUnit', minWidth: 116 },
      ],
      subColumns: [
        // { title: '序号', type: 'index', minWidth: 116 },

        // { title: '序号', type: 'index', minWidth: 116 },
        { title: '来源单据', key: 'referCode', minWidth: 116 },
        { title: '商品通用名', key: 'approvedDrugName', minWidth: 116 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '确认单价', key: 'realPriceWithTax', minWidth: 116 },
        { title: '单价', key: 'priceBeforeTax', minWidth: 116 },
        { title: '数量', key: 'num', minWidth: 116 },
        { title: '确认税率', key: 'realInputTaxRate', minWidth: 116 },
        { title: '不含税单价', key: 'realPriceAfterTax', minWidth: 116 },
        { title: '单个税额', key: 'realTax', minWidth: 116 },
        { title: '含税总金额', key: 'realTotalPriceBeforeTax', minWidth: 116 },
        { title: '总税额', key: 'realTotalTax', minWidth: 116 },
      ],
      PayablesCount: 0,
      PayablesPage: 1,
      PayablesSize: 10,
      keywords: '',
      checkTime: '',
      info: {
        financePayment: {
          invoiceCode: '',
          invoiceDate: null,
          supplierId: '',
          comment: '',
        },
        financePayableInfoList: [],
      },
      ruleValidate: {},
      paidColumns: [
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '金额', key: 'amount', minWidth: 116 },
        {
          title: '类型',
          key: 'payWay',
          minWidth: 116,
          render: (h, { row }) => h('span', this.payWayMap.get(row.payWay)),
        },
        {
          title: '状态',
          key: 'statusName',
          minWidth: 116,
        },
        { title: '备注', key: 'remark', minWidth: 116 },
        {
          title: '编辑',
          key: 'action',
          minWidth: 116,
          render: (h, { row, index }) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                disabled: row.status === 3,
              },
              on: {
                click: () => {
                  this.formModel = utils.deepClone(row);
                  this.getListAvailablePrepayment(() => {
                    this.modal.type = 2;
                    this.modal.index = index;
                    this.formModel.payWayBak = this.formModel.payWay;

                    // 付款类型为预付 要显示当前预付的剩余可用金额
                    if (this.formModel.payWay === 5) {
                      const currentPrepayment = this.preRecordList.find(item => item.id === this.formModel.prepaymentId);
                      if (currentPrepayment) {
                        this.formModel.allAvailablePrepaymentAmount = currentPrepayment.availablePrepaymentAmount;
                      } else {
                        this.$Message.error('当前预付已经被使用，请重新选择');
                      }
                    }
                  });
                },
              },
            }, '编辑'),
            h('lk-button', {
              props: {
                type: 'text',
                disabled: row.status === 3,
              },
              on: {
                click: () => {
                  this.paidList.splice(index, 1);
                },
              },
            }, '删除'),
          ]),
        },
      ],
      paidList: [], // 付款记录列表
      paidListBak: [], // 用于判断已经审批通过的付款记录有没有更改付款记录
      preRecordList: [], // 付款信息中的预付记录
      modal: {
        visiable: false,
        loading: false,
        type: 1, // 1是新增 2是编辑
        index: null, // 修改标识
      },
      tempAllAvailablePrepaymentAmount: 0,
      formModel: {
        payWay: null,
        prepaymentId: null,
        amount: null,
        allAvailablePrepaymentAmount: 0,
        remark: null,
      },
      formRules: {
        payWay: [
          {
            required: true,
            message: '请选择付款类型',
          },
        ],
        amount: [
          {
            required: true,
            message: '请输入付款金额',
          },
          {
            validator: (rule, value, callback) => {
              if (value === 0) {
                callback(new Error('付款金额不能为0'));
              }
              if (this.formModel.payWay === 5 && value > this.formModel.allAvailablePrepaymentAmount) {
                callback(new Error('付款金额必须小于预付金额'));
              }
              callback();
            },
          },
        ],
        prepaymentId: [
          {
            required: true,
            message: '请选择预付记录',
          },
        ],
      },
    };
  },
  methods: {
    handleChange(val) {
      if (!this.isClear) {
        this.changeSupplier = true;
      } else {
        this.tempSupplier = val;
      }
      if (val) {
        this.isClear = false;
      } else {
        this.isClear = true;
      }
    },
    handleSelect(selection) {
      this.tempPayables = utils.deepClone(this.PayablesList);
      selection.forEach((item) => {
        if (!this.selectedIds.includes(item.id)) {
          this.tempPayables.push(item);
        }
      });
    },
    validData(type) {
      if (!this.PayablesList.length) {
        this.$Message.error('请添加付款明细');
        return false;
      }

      if (!this.paidList.length) {
        this.$Message.error('请添加付款记录明细');
        return false;
      }

      // 总金额小于0的情况下，不允许使用应付
      if (this.amount.totalPrice < 0 && this.payTypes.includes(5)) {
        this.$Message.error('付款总金额小于0时，不能使用预付');
        return;
      }
      if (this.amount.totalPrice < 0 && Number(this.amount.totalPrice) !== Number(this.paidAmount)) {
        this.$Message.error('总付款金额为负数，仅支持一次性付款');
        return;
      }

      if (Math.abs(this.amount.totalPrice) < Math.abs(this.paidAmount)) {
        this.$Message.error('总付款金额高于应付，请核实后再提交');
        return;
      }

      // 针对已经审批通过的付款记录，如果没有更改付款记录 不用提交和保存
      const isRecordEqual = JSON.stringify(this.paidList) === JSON.stringify(this.paidListBak);
      if (isRecordEqual && this.info.financePayment.status === 3 && this.paidList.every(item => item.status !== 1)) {
        this.$Message.error(`当前付款记录没有任何变更，无需${type === 1 ? '保存' : '提交'}`);
        return;
      }

      const temp = utils.deepClone(this.info);
      temp.financePayableList = [];
      temp.financePaymentRecordList = [];
      this.PayablesList.forEach((item) => {
        temp.financePayableList.push({
          id: item.id,
        });
      });

      // 付款记录
      this.paidList.forEach((item) => {
        const data = utils.deepClone(item);
        data.createTime = utils.toTimestamp(data.createTime);
        if (data.status !== 1) {
          delete data.createTime;
        }
        temp.financePaymentRecordList.push(data);
      });
      return temp;
    },
    save() {
      let temp = this.validData(1);
      if (!temp) {
        return;
      }

      this.saveLoading = true;
      const finalAction = this.financePaymentId ? finance.editFinancePayment : finance.addFinancePayment;
      temp = this.paramsFileter(temp);
      finalAction(temp).then((res) => {
        this.saveLoading = false;
        if (res.data.status === 200) {
          this.$Message.success(this.financePaymentId ? '修改成功' : '新建成功');
          setTimeout(() => {
            this.handleToList();
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
        this.saveLoading = false;
      }).catch((err) => {
        this.saveLoading = false;
        utils.handleError(err);
      });
    },
    paramsFileter(params) {
      delete params.financePayableVoList;
      delete params.payableVoInfoList;
      delete params.processedRecordList;
      return params;
    },
    submit() {
      let temp = this.validData(2);
      if (!temp) {
        return;
      }

      this.submitLoading = true;
      let finalAction = finance.addAndSubmitFinancePayment;
      if (this.financePaymentId) {
        finalAction = finance.submitFinancePayment;
        temp.financePaymentId = this.financePaymentId;
      }
      temp = this.paramsFileter(temp);

      // debugger;

      finalAction(temp).then((res) => {
        this.submitLoading = false;
        if (res.data.status === 200) {
          this.$Message.success(this.financePaymentId ? '提交成功' : '新建提交成功');
          setTimeout(() => {
            this.handleToList();
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitLoading = false;
      }).catch((err) => {
        this.submitLoading = false;
        utils.handleError(err);
      });
    },

    // handleSeletAll(list) {
    //   this.tempPayablesList = utils.deepClone(list) ;
    //   // console.log(list);
    // },
    confirmPayables() {
      this.PayablesList = utils.deepClone(this.tempPayables);
      this.showPayables = false;
    },
    handlePayablesPage(val) {
      this.PayablesPage = val;
      this.getData();
    },
    handlePayablesSize(val) {
      this.PayablesSize = val;
      this.getData();
    },
    handleSearch() {
      this.PayablesPage = 1;
      this.getData(this.keywords);
    },
    getData() {
      // const tempDate = this.PayablesQuery.invoiceDate;
      // if (this.PayablesQuery.invoiceDate) {
      //   tempDate = new Date(this.PayablesQuery.invoiceDate).getTime();
      // }
      this.$store.commit('setDisableLoading', true);
      this.payableLoading = true;
      finance.getlistUnRelatePayment({
        page: this.PayablesPage,
        size: this.PayablesSize,
        supplierId: this.info.financePayment.supplierId,
        invoiceCode: this.PayablesQuery.invoiceCode,
        invoiceDate: this.PayablesQuery.invoiceDate,
        paymentId: this.financePaymentId,
        // page:this.page
      }).then((res) => {
        if (res.data.status === 200) {
          this.tempPayablesList = [];
          this.PayablesCount = res.data.data.count;
          res.data.data.list.forEach((item) => {
            // item.financePayable.subList = item.financePayableInfoList;
            item.financePayable.subList = [];
            item.financePayableInfoList.forEach((el) => {
              const result = {};
              utils.exchangeTable(el, result);
              // result.priceAfterTax = utils.exchangePercent(result.priceAfterTax);
              // result.priceBeforeTax = utils.exchangePercent(result.priceBeforeTax);
              // result.totalPriceBeforeTax = utils.exchangePercent(result.totalPriceBeforeTax);
              // result.totalPriceAfterTax = utils.exchangePercent(result.totalPriceAfterTax);
              // result.totalTax = utils.exchangePercent(result.totalTax);
              // result.tax = utils.exchangePercent(result.tax);
              result.taxRate += '%';
              item.financePayable.subList.push(result);
            });
            const listItem = utils.deepClone(item.financePayable);
            // listItem.invoiceAmount = utils.exchangePercent(listItem.invoiceAmount);
            // listItem.invoiceTotalTax = utils.exchangePercent(listItem.invoiceTotalTax);
            // listItem.amount = utils.exchangePercent(listItem.amount);
            // listItem.totalTax = utils.exchangePercent(listItem.totalTax);
            listItem.invoiceDate = utils.exchangeTime(listItem.invoiceDate);
            // console.log(listItem.totalTax);

            listItem._checked = this.selectedIds.includes(listItem.id);
            listItem._disabled = this.selectedIds.includes(listItem.id);
            // listItem.invoiceTotalTax = utils.exchangePercent(listItem.invoiceTotalTax);

            // result.purchaseReceiptInfoPriceBeforeTax = utils.exchangePercent(result.purchaseReceiptInfoPriceBeforeTax);

            // result.inspectionInfoAmount = utils.exchangePercent(result.inspectionInfoAmount);
            // result.purchaseReceiptInfoPriceBeforeTax = utils.exchangePercent(result.purchaseReceiptInfoPriceBeforeTax);

            this.tempPayablesList.push(listItem);
          });
        } else {
          this.$Message.error(res.data.error);
        }
        this.payableLoading = false;
      }).catch((err) => {
        this.payableLoading = false;
        utils.handleError(err);
      });
    },
    getSuppliers() {
      return new Promise((resolve) => {
        finance.getFinancePaymentSupplier().then((res) => {
          if (res.data.status === 200) {
            res.data.data.forEach((item) => {
              this.suppliers.push(item);
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getListAvailablePrepayment(callback) {
      this.preRecordList = [];
      this.$store.commit('setDisableLoading', true);
      finance.getListAvailablePrepayment({ supplierId: this.info.financePayment.supplierId }).then((res) => {
        const data = res.data.data;
        data && data.financePrepaymentVoList.forEach((item) => {
          const result = Object.assign(item, item.financePrepayment);
          delete result.financePrepayment;
          result.payTime = utils.formatDate(result.payTime);
          result.payItem = `${item.payTime} ${item.availablePrepaymentAmount}`;
          this.preRecordList.push(result);
        });
        this.formModel.allAvailablePrepaymentAmount = (data && data.allAvailablePrepaymentAmount) || 0;
        this.tempAllAvailablePrepaymentAmount = this.formModel.allAvailablePrepaymentAmount;
        this.modal.visiable = true;
        callback && callback();
      }).catch((error) => {
        utils.handleError(error);
      });
    },
    getDetails() {
      finance.getFinancePaymentDetail({ financePaymentId: this.financePaymentId }).then((res) => {
        if (res.data.status === 200) {
          const temp = res.data.data;
          temp.financePayableVoList.forEach((item) => {
            item.financePayable.subList = [];
            item.financePayableInfoList.forEach((el) => {
              const result = {};
              utils.exchangeTable(el, result);
              result.realInputTaxRate += '%';
              item.financePayable.subList.push(result);
            });
            const listItem = utils.deepClone(item.financePayable);
            listItem.invoiceDate = utils.exchangeTime(listItem.invoiceDate);
            this.PayablesList.push(listItem);
            this.tempPayables.push(listItem);
          });
          temp.financePaymentRecordList.forEach((item) => {
            item.createTime = utils.formatDate(item.createTime);
            this.paidList.push(item);
          });

          this.paidListBak = utils.deepClone(this.paidList);
          this.info = utils.deepClone(temp);
          this.infosArr[0] = {
            name: '门店名称:',
            value: this.info.financePayment.storeName,
          };
          this.infosArr[1] = {
            name: '供应商:',
            value: this.info.financePayment.supplierName,
          };
          this.infosArr[2] = {
            name: '创建人:',
            value: this.info.financePayment.createUserName,
          };
          this.infosArr[3] = {
            name: '创建时间:',
            value: utils.exchangeTimeToSecond(this.info.financePayment.createTime),
          };
          this.tempSupplier = this.info.financePayment.supplierId;
          //  this.isClear = true;
          this.isClear = false;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPaymentIDsList() {
      finance.payableToPaymentList(this.$route.params).then((res) => {
        if (res.data.status === 200) {
          res.data.data.forEach((row) => {
            this.info.financePayment.supplierId = row.financePayable.supplierId;
            row.financePayable.subList = [];
            row.financePayableInfoList.forEach((subRow) => {
              const result = {};
              utils.exchangeTable(subRow, result);
              // result.purchaseReceiptInfoPriceBeforeTax = utils.exchangePercent(result.purchaseReceiptInfoPriceBeforeTax);
              // result.purchaseReceiptInfoTotalAmountWithoutTax = utils.exchangePercent(result.purchaseReceiptInfoTotalAmountWithoutTax);
              // result.priceBeforeTax = utils.exchangePercent(result.priceBeforeTax);
              // result.totalTax = utils.exchangePercent(result.totalTax);
              // result.priceAfterTax = utils.exchangePercent(result.priceAfterTax);
              // result.totalPriceBeforeTax = utils.exchangePercent(result.totalPriceBeforeTax);
              // result.tax = utils.exchangePercent(result.tax);
              result.taxRate += '%';
              row.financePayable.subList.push(result);
            });
            row.financePayable.invoiceDate = utils.exchangeTime(row.financePayable.invoiceDate);
            // row.financePayable.invoiceAmount = utils.exchangePercent(row.financePayable.invoiceAmount);
            // row.financePayable.invoiceTotalTax = utils.exchangePercent(row.financePayable.invoiceTotalTax);
            // row.financePayable.amount = utils.exchangePercent(row.financePayable.amount);
            // row.financePayable.totalTax = utils.exchangePercent(row.financePayable.totalTax);
            this.tempPayables.push(row.financePayable);
            this.PayablesList.push(row.financePayable);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleDoPrePaymentAdd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.modal.loading = true;
          const params = utils.deepClone(this.formModel);
          if (this.modal.type === 1) {
            params.createTime = utils.formatDate(Date.now()); // 创建时间
            params.statusName = '草稿';
            params.status = 1;
            this.paidList.unshift(params);
          } else {
            this.paidList.splice(this.modal.index, 1, params);
          }
          this.modal.loading = false;
          this.cancelModal();
        } else {
          this.$Message.error(' 请按照要求填写');
        }
      });
    },
    handleTypeChange() {
      this.formModel.allAvailablePrepaymentAmount = this.tempAllAvailablePrepaymentAmount;
    },
    handlePreRecordChange(preitem) {
      this.preRecordList.forEach((item) => {
        if (item.id === preitem.value) {
          this.formModel.allAvailablePrepaymentAmount = item.availablePrepaymentAmount;
        }
      });
    },
    handleShowAdd() {
      if (!this.info.financePayment.supplierId) {
        this.$Message.error('请先选择供应商');
        return;
      }
      this.modal.type = 1; // 新增
      this.preRecordList = [];
      this.formModel.payWayBak = '';
      this.getListAvailablePrepayment();
    },
    cancelModal() {
      this.$refs.form.resetFields();
      this.modal.visiable = false;
    },
    handleToList() {
      this.$router.push({
        name: 'payment',
      });
    },
    confirmChangeSupplier() {
      this.PayablesList = [];
      this.changeSupplier = false;
      this.paidList = [];
    },
    // 总金额小于0的情况下，不允许使用预付
    disablePreRecord(payWay) {
      return this.amount.totalPrice < 0 && payWay === 5;
    },
  },
  created() {
    this.financePaymentId = this.$route.params.id;
    if (this.financePaymentId) {
      this.getDetails();
    } else {
      this.getSuppliers().then(() => {
        if (this.$route.params.financePayableList) {
          this.disableSupplier = true;
          this.getPaymentIDsList();
        }
      });
    }
  },
};

</script>
<style lang="less" >
.PaymentPayables .noEqual{
  color: #FF4D07
}
</style>
